module.exports = __webpack_public_path__ + "static/media/whatfixpage.e55660c2.svg";